import {
  GETCONSALTATION,
  CREATECONSALTATION,
  UPDATECONSALTATION,
  DELETECONSALTATION,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    // case CREATECONSALTATION:
    //     return {
    //             ...state,
    //             liveConsaltationSaveStatus: action.payload.success,
    //             }
    case GETCONSALTATION:
      return {
        ...state,
        liveConsaltationList: action.payload.data,
      };
    case UPDATECONSALTATION:
      return {
        ...state,
        liveConsaltationUpdateStatus: action.payload.success,
      };

    case DELETECONSALTATION:
      return {
        ...state,
        liveConsaltationDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}
